import React, { useState } from 'react';
import './Projects.css';

const Projects = () => {
  const [filter, setFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: "Digit Generator using GANs",
      description: "A digit generator using Generative Adversarial Networks (GANs) to generate Hand written digits.",
      image: "/api/placeholder/400/250",
      technologies: ["Python", "TensorFlow", "openCV"],
      category: "AI/ML",
      githubUrl: "https://github.com/agasthyarkumar/Digit-Generator-Using_GAN",
      liveUrl: null,
      featured: true
    },
    {
      id: 2,
      title: "ECG Classification using Deep Learning",
      description: "A ResNet-18 based deep learning model to classify ECG signals into different categories such as Normal, AFib, and other arrhythmias.",
      image: "/api/placeholder/400/250",
      technologies: ["Python", "TensorFlow", "OpenCV"],
      category: "AI/ML",
      githubUrl: "https://github.com/agasthyarkumar/Adhvara-ECG-Project",
      liveUrl: null,
      featured: true
    },
    {
      id: 3,
      title: "Mediax",
      description: "Media streamining web application that allows users to stream movies and TV shows with a user-friendly interface and personalized recommendations.",
      image: "/api/placeholder/400/250",
      technologies: ["ReactNative", "Node.js", "JavaScript", "TypeScript", "iOS", "Android", "Expo"],
      category: ["Web", "Mobile"],
      githubUrl: "https://github.com/agasthyarkumar/Mediax",
      liveUrl: null,
      featured: false
    },
    {
      id: 4,
      title: "ImmunoML - Self Healing MLOPs Pipeline",
      description: "A truly self-healing production MLOps pipeline that automatically detects and fixes issues across the entire ML lifecycle. Features automated data quality fixes, model rollback, drift-based retraining, and service recovery.",
      image: "/api/placeholder/400/250",
      technologies: ["MLOPs", "Python", "FastAPI", "Docker", "MLflow", "ML", "CI/CD", "Backend"],
      category: ["Web", "AI/ML"],
      githubUrl: "https://github.com/agasthyarkumar/MLOPs-Project",
      liveUrl: null,
      featured: true
    },
    {
      id: 5,
      title: "The EYES",
      description: "Media streamining web application that allows users to stream movies and TV shows with a user-friendly interface and personalized recommendations.",
      image: "/api/placeholder/400/250",
      technologies: ["HTML", "CSS", "JavaScript", "TypeScript"],
      category: ["Web", "Wallpaper"],
      githubUrl: "https://github.com/agasthyarkumar/The-eyes-using-HTML-and-CSS",
      liveUrl: null,
      featured: false
    }
  ];

  const categories = ['all', 'AI/ML', 'Web', 'Mobile', 'Data Science'];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(project => {
        if (Array.isArray(project.category)) {
          return project.category.includes(filter);
        }
        return project.category === filter;
      });

  return (
    <section id="projects" className="section">
      <div className="container">
        <h2 className="section-title fade-in">My Projects</h2>
        
        <div className="projects-filter fade-in">
          {categories.map(category => (
            <button
              key={category}
              className={`filter-btn ${filter === category ? 'active' : ''}`}
              onClick={() => setFilter(category)}
            >
              {category === 'all' ? 'All Projects' : category}
            </button>
          ))}
        </div>
        
        <div className="projects-grid fade-in">
          {filteredProjects.map(project => (
            <div key={project.id} className={`project-card ${project.featured ? 'featured' : ''}`}>
              <div className="project-image">
                <div className="image-placeholder">
                  <span>Project Screenshot</span>
                </div>
                <div className="project-overlay">
                  <div className="project-links">
                    <a 
                      href={project.githubUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="project-link"
                    >
                      <span>GitHub</span>
                    </a>
                    {project.liveUrl && (
                      <a 
                        href={project.liveUrl} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="project-link"
                      >
                        <span>Live Demo</span>
                      </a>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="project-content">
                <div className="project-header">
                  <h3 className="project-title">{project.title}</h3>
                  <span className="project-category">
                    {Array.isArray(project.category) 
                      ? project.category.join(' • ') 
                      : project.category}
                  </span>
                </div>
                
                <p className="project-description">{project.description}</p>
                
                <div className="project-tech">
                  {project.technologies.map(tech => (
                    <span key={tech} className="tech-tag">{tech}</span>
                  ))}
                </div>
                
                <div className="project-actions">
                  <a 
                    href={project.githubUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-secondary"
                  >
                    View Code
                  </a>
                  {project.liveUrl && (
                    <a 
                      href={project.liveUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      Live Demo
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;